// Benepack OMS · i18next 初始化
// 一期仅 zh-CN · en-US 占位 (Phase 3+)
// 命名空间: common (通用) · enums (codegen 同 domain.yaml) · errors (codegen 同 errs/codes.go)
//   + 模块命名空间: sales / procurement / fulfillment / finance / master / platform / identity
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import commonZh from './zh-CN/common.json';
import enumsZh from './zh-CN/enums.json';
import errorsZh from './zh-CN/errors.json';
import masterZh from './zh-CN/master.json';
import identityZh from './zh-CN/identity.json';
import tradeZh from './zh-CN/trade.json';
import financeZh from './zh-CN/finance.json';
import platformZh from './zh-CN/platform.json';
import systemZh from './zh-CN/system.json';
import reportsZh from './zh-CN/reports.json';

export const defaultNS = 'common';
export const namespaces = [
  'common',
  'enums',
  'errors',
  'master',
  'identity',
  'trade',
  'finance',
  'platform',
  'system',
  'reports',
] as const;

void i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'zh-CN',
    supportedLngs: ['zh-CN', 'en-US'],
    defaultNS,
    ns: [...namespaces],
    resources: {
      'zh-CN': {
        common: commonZh,
        enums: enumsZh,
        errors: errorsZh,
        master: masterZh,
        identity: identityZh,
        trade: tradeZh,
        finance: financeZh,
        platform: platformZh,
        system: systemZh,
        reports: reportsZh,
      },
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'oms.lang',
    },
    interpolation: { escapeValue: false },
  });

export default i18n;
